import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { btnPrimary } from "@/components/admin/ui";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { if (!token) toast.error("Missing reset token"); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.resetPassword({ token, password });
      setDone(true);
      toast.success("Password reset. You can sign in now.");
    } catch (err) { toast.error(formatApiErrorDetail(err?.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F9F8F6] px-6" data-testid="reset-password-page">
      <div className="w-full max-w-sm text-center">
        <KeyRound size={40} className="mx-auto text-[#1F2A22]" />
        <h1 className="font-serif text-3xl text-[#1F2A22] mt-4">{done ? "All set" : "Set a new password"}</h1>
        {done ? (
          <>
            <p className="text-[#5C6B61] mt-2 text-sm">Your password has been updated.</p>
            <button onClick={() => navigate("/admin/login")} className={`${btnPrimary} mt-6`} data-testid="reset-to-login">Go to sign in</button>
          </>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4 text-left">
            <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-[#E5E2DC] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F2A22]" data-testid="reset-password" />
            <input type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full border border-[#E5E2DC] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F2A22]" data-testid="reset-confirm" />
            <button type="submit" disabled={busy || !token} className={`${btnPrimary} w-full py-3`} data-testid="reset-submit">
              {busy ? <Loader2 size={16} className="animate-spin" /> : "Reset password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
